import ng from 'angular';
import angular from 'angular';
import moment from 'moment';
import { AgenciasService } from '../../../../Financas/Agencias/agencias.service';
import { StatusProcessoEnum } from '../../enums/statusprocesso';
import { TipoContaPixEnum } from '../../../../../shared/enums/TipoContaPixEnum';
import {
    contaBancoValida,
    getMensagemContaBanco,
    digitoVerificadorContaValido,
    getMensagemDigitoVerificador,
    TipoPagamentoEnum
} from '../../../../../utils/dados-bancarios';

export class MeurhAdmissoesOutrasinformacoesFormController implements ng.IController {

    static $inject = ['$rootScope', '$scope', 'AgenciasService'];

    public entity: any;
    public action: string;
    public form: angular.IFormController;

    public agenciaNumero: any = 'numero';

    public statusProcessoEnum = StatusProcessoEnum;

    public anoMinimo: moment.Moment;
    public anoMaximo: moment.Moment;

    public tipoContaPixEnum = TipoContaPixEnum;

    public exibeAlertaConta: boolean = false;
    public focoInputConta: boolean = false;

    public exibeAlertaDigitoVerificador: boolean = false;
    public focoInputDigitoVerificador: boolean = false;

    public agenciaExistente = false;

    public tiposPagamentoChecaDv = [
        TipoPagamentoEnum.CONTA_CORRENTE,
        TipoPagamentoEnum.CONTA_POUPANCA,
        TipoPagamentoEnum.CONTA_SALARIO,
        TipoPagamentoEnum.PIX_AGENCIA_CONTA
    ];

    constructor(
        private $rootScope: angular.IRootScopeService & { session: any, configuracoes: any },
        private $scope: angular.IScope,
        private AgenciasService: AgenciasService,
    ) {
        this.$scope.$on('agencias_list_finished', (_, args: { numero: string; digitoverificador: string; }[]) => {
            if (args && args.length) {
                const agencia = args.find(agencia => agencia.numero === this.entity.agencianumero);
                if (agencia) {
                    this.entity.agencianumerodv = agencia.digitoverificador;
                }
                this.agenciaExistente = !!agencia;
                return;
            }
            this.agenciaExistente = false;
        });
    }

    $onInit(): void {
        this.bloqueiaAnoMinimo();
        this.bloqueiaAnoMaximo();

        if (this.action === 'show') {
            this.agenciaNumero = 'agencianumero';
        } else {
            this.agenciaNumero = 'numero';
            if (this.action === 'update' && this.entity.agencia) {
                this.entity.agencia.numero = this.entity.agencia.agencianumero;
            }

            // se tipo de pagamento pode exibir alertas na conta e DV
            if (this.action === 'update' && this.tiposPagamentoChecaDv.includes(this.entity.tiporecebimentosalario)) {
                this.validaContaPagamento();
                this.validaDigitoVerificadorConta();
            }

        }
    }

    // início - controle do formulário
    public aplicarSemDadosBancarios(): void {
        delete this.entity.banco;
        delete this.entity.agencia;
        delete this.entity.agencianumero;
        delete this.entity.numerocontasalario;
        delete this.entity.numerocontasalariodv;
        delete this.entity.agencianumerodv;
    }

    public preencheCamposRecebimento(): void {
        if (this.entity.tiporecebimentosalario !== '') {
            this.entity.semdadosbancarios = false;
        }

        if (this.entity.tiporecebimentosalario !== '64') {
            this.entity.tipocontapix = null;
        }

        switch (this.entity.tiporecebimentosalario) {
            // cpf
            case '128':
                this.entity.chavepix = this.entity.cpf;
                break;

            // e-mail
            case '256':
                this.entity.chavepix = this.entity.email;
                break;

            // celular
            case '512':
                if (this.entity.dddcel !== undefined || this.entity.celular !== undefined) {
                    this.entity.chavepix = this.entity.dddcel + this.entity.celular;
                }
                break;

            default:
                this.entity.chavepix = '';
                break;
        }
    }

    public desabilitarNenhumTipoPagamento(): boolean {
        return !!this.$rootScope.configuracoes.DESABILITAR_NENHUM_TIPO_PAGAMENTO_ADMISSOES;
    }

    public desabilitarNenhumaInstituicaoBancaria(): boolean {
        return !!this.$rootScope.configuracoes.DESABILITAR_NENHUMA_INSTITUICAO_BANCARIA_ADMISSOES;
    }

    public limpaDadosAgenciaConta() {
        this.entity.agencianumero = null;
        this.entity.agencianumerodv = null;
        this.entity.numerocontasalario = null;
        this.entity.numerocontasalariodv = null;
        this.agenciaExistente = false;
    }

    public limpaBanco() {
        this.entity.banco = null;
    }

    public verificaAgencia() {
        this.agenciaExistente = false;
        if (this.entity.agencianumero) {
            this.AgenciasService.constructors = { banco: this.entity.banco.banco };
            this.AgenciasService.search({ search: this.entity.agencianumero });
        }
    }

    // fim - controle do formulário


    // início - alertas e verificações
    public alertaTipoPagamento(): boolean {
        return !(!!this.entity.tiporecebimentosalario) && (this.form && (this.form.tiporecebimentosalario.$dirty || this.form.$submitted));
    }

    public verificaEstabelecimento(): { estabelecimento: string } {
        if (this.entity.estabelecimento) {
            return { 'estabelecimento': this.entity.estabelecimento };
        } else {
            return { 'estabelecimento': this.$rootScope.session.entities.estabelecimento.estabelecimento };
        }
    }

    public validaContaPagamento() {
        if (!this.entity.banco || !this.entity.tiporecebimentosalario || !this.entity.numerocontasalario) {
            this.exibeAlertaConta = false;
            return;
        }

        this.exibeAlertaConta = !contaBancoValida(this.entity.banco, this.entity.tiporecebimentosalario, this.entity.numerocontasalario, this.entity.tipocontapix) &&
            !this.form.numerocontasalario?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaConta() {
        if (!this.entity.banco || !this.entity.tiporecebimentosalario || !this.entity.numerocontasalario) {
            return false;
        }

        return !this.focoInputConta && this.exibeAlertaConta;
    }

    public getMensagemAlertaConta(): string {
        return getMensagemContaBanco(this.entity.banco, this.entity.tiporecebimentosalario, this.entity.numerocontasalario, this.entity.tipocontapix);
    }

    public validaDigitoVerificadorConta() {
        if (!this.entity.banco || !this.entity.tiporecebimentosalario || !this.entity.numerocontasalariodv) {
            this.exibeAlertaDigitoVerificador = false;
            return;
        }

        this.exibeAlertaDigitoVerificador = !digitoVerificadorContaValido(this.entity.banco, this.entity.tiporecebimentosalario, this.entity.numerocontasalariodv, this.entity.tipocontapix)
            && !this.form.numerocontasalariodv?.$error?.required && this.action !== 'show';
    }

    public verificaExibicaoAlertaDigitoVerificador() {
        if (!this.entity.banco || !this.entity.tiporecebimentosalario || !this.entity.numerocontasalariodv) {
            return false;
        }

        return !this.focoInputDigitoVerificador && this.exibeAlertaDigitoVerificador;
    }

    public getMensagemAlertaDigitoVerificador(): string {
        return getMensagemDigitoVerificador(this.entity.banco, this.entity.tiporecebimentosalario, this.entity.numerocontasalariodv, this.entity.tipocontapix);
    }

    // fim - alertas e verficações


    // inicio - tratamento de dados
    private bloqueiaAnoMinimo(): void {
        this.anoMinimo = moment().subtract(120, 'years'); // > 120 anos
    }

    private bloqueiaAnoMaximo(): void {
        this.anoMaximo = moment().add(100, 'years'); // > 120 anos
    }
    // fim - tratamento de dados
}
